import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { PermissionsService } from '../../services/permission.service';
import { SchemeService } from '../../services/scheme.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-make-scheme-list',
  standalone: false,
  templateUrl: './make-scheme-list.component.html',
  styleUrl: './make-scheme-list.component.scss'
})
export class MakeSchemeListComponent implements OnInit {
  schemes = [];
  viewDetails: boolean = false;
  viewProposals: boolean = false;
  addProposalVisible: boolean = false;
  selectedScheme: any;

  get isMakeII(): boolean {
    return this.selectedScheme?.name === 'Make II';
  }
  get isMakeIII(): boolean {
    return this.selectedScheme?.name === 'Make III';
  }
  selectedPhase: any;
  phases = [];
  items = [
    { label: 'Add Proposal', command: () => (this.activeIndex = 0) },
    {
      label: 'Route Configuration',
      command: () => {
        this.apiCallForTransaction();
        this.activeIndex = 1;
      },
    },
  ];
  draftProposalColumns: any[] = [
    { field: 'proposal_name', header: 'Name', filterType: 'text' },
    { field: 'modified_on', header: 'Last Update', filterType: 'text' },
  ]
  private subscriptions = new Subscription();
  itemsPerPage: number = 9;
  currentPage: number = 1;
  activeTabIndex: number = 0;
  proposalData = [];
  filteredRecentProposals: any[];
  activeIndex: number = 0;
  proposalForm: FormGroup;
  routeForm: FormGroup;
  roleList = []
  userList = []
  unitList = []
  filteredStagesList: any[] = []
  roleID: number | null = null;
  userID: any;
  isUpdateProposal: boolean = false;
  currentSchemeId: any = 47;
  currentsubSchemeId: any;
  selectedProposal: any;
  activePhaseId: any;
  stages: any;
  currentUserRoleId: string;
  completionSum: any;
  RouteUserList: any[] = [];
  userCols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    {
      field: 'proposal_step.name',
      header: 'Proposal Step Name',
      filterType: 'text',
    },
    { field: 'role.name', header: 'Role', filterType: 'text' },
  ];
  isDeleteProposal: boolean = false;
  stepId: number | null = null;
  selectedPhaseId: any;
  activeTabName: any;
  addMode: string;
  currentPhaseName: any;
  transactionPhaseStages: any;
  searchProposalQuery: any;
  stagesList: any;
  userListCopy: any[];


  // New design
  activeTab: any = 'initiation';
  proposals: Proposal[] = [];
  filteredProposals: Proposal[] = [];
  currentRole: string = 'doi';
  selectAll: boolean = false;

  stats = { total: 0, pending: 0, screening: 0, approved: 0 };

  filters = { category: '', status: '', priority: '', valuation: '' };

  // Modal control
  detailsModalOpen = false;
  challengeForm: FormGroup;
  categoryOptions = [
    { label: 'To Move', value: 'To Move' },
    { label: 'To Fight', value: 'To Fight' },
    { label: 'To Float', value: 'To Float' },
  ];
  priorityOptions = [
    { label: 'High', value: 'High' },
    { label: 'Medium', value: 'Medium' },
    { label: 'Low', value: 'Low' },
  ];
  statusOptions = [
    { label: 'Launch', value: 'Launch' },
    { label: 'Duplicate', value: 'Duplicate' },
    { label: 'Reject', value: 'Reject' },
  ];
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  draftSotr: File;
  draftSotrFile: File | null = null;
  supportingDocsFiles: File | null = null;
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  PDSGenId: any;
  screening: any;
  apiUrl = environment.APIUrl;
  needGenData: any;
  needGenId;
  @Input() isEditable: boolean = false;
  selectedChallenges: Proposal[];
  isEditMode = false;
  currentAction: 'view' | 'edit' = 'view';
  IRAremarks: string;
  selectedChallengeCount: any[];
  schemeID: any = 47;
  steps: any;
  currentStage: number = 1;
  scheme={
    6:{name: 'Make I', id: 6},
    12:{name: 'Make II', id: 12},
    14:{name: 'Make III', id: 14},
  }
  constructor(
    private apiService: ApiService,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private schemeService: SchemeService,
    private permissionService: PermissionsService
  ) {
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: ['', Validators.required],
      user: ['', Validators.required],
      unit: ['', Validators.required],
      level: ['', Validators.required],
      approved: [false, Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  seek_proposal = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const scheme_id = params['scheme_id'] || 47;
      this.currentSchemeId = scheme_id || 47;
      const seekProposal = params['seek_proposal'];
      const sub_scheme_id = params['sub_scheme_id'];
      this.proposalForm.get('isSeekProposal')?.setValue(seekProposal === 'true');
      if(this.proposalForm.get('isSeekProposal')?.value) {
        this.proposalForm.get('scheme')?.setValue(this.scheme[sub_scheme_id]);
        this.selectScheme(this.scheme[sub_scheme_id]);
      }
    });
    this.getSchemes();
    
    this.proposalForm = this.fb.group({
      seek_proposal:[false],
      id: [''],
      proposalName: ['', Validators.required],
      description: [''],
      scheme: [null, Validators.required],
      status: [1],
      nomenclature: ['', Validators.required],
      // onDualUseTechnologyChange: [null],
      brief_description: [''],
      requirement_met: [''],
      // how_is_requirement_met_presently: [''],
      qtyReqd: [''],
      qtyPrototype: ['', Validators.required],
      qtyBulk: ['', Validators.required],
      development_prototype: [''],
      estimatedDevelopmentCost: [''],
      estimatedUnitCost: [''],
      llp: [''],
      bulk_cost: [''],
      exchequer:[''],
      development_cost:[''],
      dual_technology:[''],
      poev: [''],
      lpyear: [null],
      indigenously_designed: [''],
      capability_infrastructure: [''],
      ltpp: [''],
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      lead_development: [''],
      indigenise_equipment: [''],
      rfi_indigenous: [''],
      collaboration_envisaged: [''],
      drdo_psu: [''],
      technical_specifications: [''],
      operational_requirement: [''],
      drawings_manuals: [''],
      sample_indigenisation: [''],
      annual_Acquisition: [''],
      trials_environments: [''],
      photograph_item: [''],
      export_potential: [''],
      project_similar: [''],
      approval_apso: [''],
      nodalOfficerDetails: [''],
      critical_technology: [''],
      drdo_infrastructure: [''],
      trial_infrastructure: [''],
      revenue_idex: [''],
      vinatge_oem: [''], // Make III only
    });
    this.routeForm = this.fb.group({
      step: ['', Validators.required],
      role: [''],
      user: [''],
      unit: [''],
      level: [{ value: '', disabled: true }],
      approved: [false]
    })
    this.switchRole('doi');

    this.challengeForm = this.fb.group({
      organisation: ['', Validators.required],
      category: [''],
      priority: [''],
      challenge_status: [''],
      ip_status: [''],
      releaseDate: ['', Validators.required],
      approvedBy: [''],
      coordinatingAgency: ['', Validators.required],
      technologyDomain: ['', Validators.required],

      challengeTitle: ['', Validators.required],
      nodalOfficer: ['', Validators.required],
      problemStatement: ['', Validators.required],
      challengeBrief: ['', Validators.required],
      prototypeDevelopment: ['', Validators.required],
      requirement: ['', Validators.required],
      ipValue: [''],
      functionalAdvantages: ['', Validators.required],
      domestic: ['', Validators.required],
      substitution: ['', Validators.required],
      preliminaryScope: ['', Validators.required],
      competitiveSolution: ['', Validators.required],
      potentialMarket: ['', Validators.required],
      riskAssessment: ['', Validators.required],
      mpoQty: ['', Validators.required],
    });
    this.route.queryParams.subscribe(params => {
      const schemeId = params['scheme_id'] || 47;
      this.schemeID = schemeId || 47;
    });
    if (this.activeTab == 'initiation') {
      this.gettableData();
    }
    this.items = [
      { label: 'Add Proposal', command: () => (this.activeIndex = 0) },
    ];

    // Show "Skip Stages" **only if it's update mode**
    if (this.isUpdateProposal) {
      this.items.push({
        label: 'Skip Stages',
        command: () => (this.activeIndex = 1),
      });
    }

    this.items.push({
      label: 'Route Configuration',
      command: () => {
        this.apiCallForTransaction();
        this.activeIndex = this.items.length - 1;
      },
    });

    // Initialize form on initial load if "New Scheme" tab is active (default)
    // Don't call getDraftProposals() here - it will be called when a sub-scheme is selected
    if (this.activeStatusTabIndex?.tab === 0) {
      this.initializeNewProposalForm();
    }
  }
  onTabChange(event: any): void {
    this.activeTabIndex = event.index;
    this.currentPage = 1; // ✅ Reset to page 1 on tab switch
    this.activePhaseId = this.phases[event.index]?.id;
    this.selectedPhaseId = this.phases[event.index]?.id;
    this.getProposal(1)
  }
  onPageChange(event: any) {
    const rows = event.rows;
    const first = event.first;
    const page = first / rows + 1;
    this.getProposal(page);
    this.currentPage = page;
  }
  getSchemes() {
    let url = this.currentSchemeId ? `/master/scheme/sub/details/?id=${this.currentSchemeId}` : `/master/scheme/sub/details/`
    const sub = this.apiService
      .getAPI(url)
      .subscribe((res: any) => {
        this.schemes = res[0].sub_scheme
      });
    this.subscriptions.add(sub);
  }
  selectScheme(scheme: any) {
    this.getSchemewisePhase(scheme.id)
    this.viewDetails = true;
    this.selectedScheme = scheme;
    // Auto-fill scheme in form if "New Scheme" tab is active
    if (this.activeStatusTabIndex && this.activeStatusTabIndex.tab === 0) {
      this.proposalForm.patchValue({
        scheme: scheme.id
      });
    }
  }
 onDualUseTechnologyChange(value: boolean): void {
  this.proposalForm.get('dual_technology')?.setValue(value);
}
  viewProposal(scheme: any, phase: any) {
    this.viewProposals = true;
    this.selectedPhase = phase;
  }
  getProposal(page: number = 1) {
    this.proposalData = [];
    let url = `/master/proposals/?scheme__phase=${this.selectedPhaseId}&scheme=${this.currentsubSchemeId}&page=${page}`;

    // Add status filter if not on "New Scheme" tab
    if (this.activeStatusTabIndex && this.activeStatusTabIndex.tab === 1 && this.activeStatusTabIndex.status !== 'form') {
      url += `&proposal_status=${this.activeStatusTabIndex.status}`;
    }

    const sub = this.apiService
      .getAPI(url)
      .subscribe((res: any) => {
        this.proposalData = res.results || res.data || [];
        this.totalCount = res.count || this.proposalData.length;
        this.filteredRecentProposals = [...this.proposalData];
      });
    this.subscriptions.add(sub);
  }
  getPagedProposals(): any[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.proposalData.slice(start, end);
  }
  addProposal(mode: 'new' | 'existing' = 'new') {
    // this.transactionPhaseStages = [];
    this.addMode = mode;
    this.activeTabName = this.phases[this.activeTabIndex]?.name || '';
    // Don't reset form if we're opening from New Scheme tab - preserve the values
    // Only reset routeForm
    this.routeForm.reset();
    this.getSchemes();
    // Set scheme if not already set
    if (!this.proposalForm.get('scheme')?.value) {
      this.proposalForm.get('scheme')?.patchValue(this.currentsubSchemeId || parseInt(this.currentSchemeId));
    }
    this.activeIndex = 0;
    this.addProposalVisible = true;
    this.isUpdateProposal = false;
    // this.currentPhaseName = '';

  }
  onSubmit() {
    const data = {
      name: this.proposalForm.get('proposalName')?.value,
      description: this.proposalForm.get('description')?.value,
      scheme: this.proposalForm.get('scheme')?.value,
      phase: this.activePhaseId,
      status: 1,
    };
    if (this.isUpdateProposal) {
      const sub = this.apiService
        .putAPI(`/master/proposals/${this.selectedProposal.id}/`, data)
        .subscribe((res: any) => {
          this.selectedProposal = res;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Proposal Updated Successfully',
          });
          this.apiCallForTransaction()
          // this.confirmSkipStage()
          this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
          this.getProposal();
          this.activeIndex = 1;
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.apiService
        .postAPI('/master/proposals/', data)
        .subscribe((res: any) => {
          this.selectedProposal = res;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Proposal Added Successfully',
          });
          // this.confirmSkipStage()
          this.getStages(this.proposalForm.get('scheme')?.value, 'no');
          this.getProposal();
          if (this.addMode === 'existing') {
            this.insertIntermediateSteps(
              this.proposalForm.get('scheme')?.value,
              this.activePhaseId
            );
            this.activeIndex = 1;
            this.currentPhaseName = this.activeTabName;
            this.fetchAndSubmitProposalSteps(
              this.proposalForm.get('scheme')?.value,
              this.proposalForm.get('scheme')?.value?.name,
              this.selectedProposal.id,
              this.activePhaseId
            );
          } else {
            this.activeIndex = 1; // go to next step directly
            this.apiCallForTransaction()
            // this.setActiveIndex(this.activeIndex)
          }
        });
      this.subscriptions.add(sub);
    }
  }
  insertIntermediateSteps(scheme: any, phaseId: any) {
    const currentPhase = this.phases?.find((p) => p.id === phaseId);
    const phaseName = currentPhase?.name;

    this.currentPhaseName = phaseName;

    const firstStep = { label: 'Add Proposal' };
    const mandatoryStep = { label: 'Mandatory steps from Previous Phases' };
    const lastSteps = [
      { label: 'Skip Stages' },
      { label: 'Route Configuration' },
    ];

    const newSteps = [];

    if (
      phaseName === 'Prototype Development' ||
      phaseName === 'Mass Production'
    ) {
      newSteps.push(mandatoryStep);
    }

    this.items = [firstStep, ...newSteps, ...lastSteps];
  }
  fetchAndSubmitProposalSteps(
    schemeId: number,
    scheme_Name: string,
    proposalId: number,
    phaseId: number
  ): void {
    let optionalStepCodes: string[] = [];
    const scheme = this.schemes.find((s) => s.id === schemeId);
    if (!scheme) {
      console.error('Scheme not found for ID:', schemeId);
      return;
    }

    const schemeName = scheme.name;
    optionalStepCodes = [
      'R-ND',
      'R-AIP',
      'R-NOQA',
      'R-VI',
      'R-RFP-SOC',
      'R-AoN',
      'R-PRFPM',
      'R-FS',
      'R-PBC',
      'R-TEC',
      'R-BM',
      'R-FO',
      'R-PSO',
      'Rev_011',
      'Rev_012',
      'idex_007',
      'Rev_017',
      'Rev_013',
      'Rev_014',
    ];

    const index = this.phases.findIndex(
      (p) => p.name === this.currentPhaseName
    );

    if (index > 0) {
      for (let i = 0; i < index; i++) {
        const phase = this.phases[i];

        const sub = this.apiService
          .getAPI(
            `/master/scheme-step/mapping/?scheme=${schemeId}&phase_id=${phase.id}`
          )
          .subscribe(
            (res: any) => {
              const stagePayload = res.map((item: any) => {
                const skipped = !optionalStepCodes.includes(item.step.code);

                return {
                  step_mapping: item.id,
                  name: item.step.name,
                  sequence: item.sequence,
                  skipped,
                  code: item.step.code,
                  remark: '',
                  isSelected: false,
                  ...(skipped === false && { make_initiator: true }), // ✅ Conditionally add the key
                };
              });

              this.transactionPhaseStages.push({
                phase: phase,
                stages: stagePayload,
              });

              this.apiService
                .postAPI(
                  `/transaction/proposals/${proposalId}/steps/`,
                  stagePayload
                )
                .subscribe(
                  (submitRes: any) => { },
                  (submitErr) => { }
                );
            },
            (err) => { }
          );
        this.subscriptions.add(sub);
      }
    }
  }
  deleteProposal(proposal?: any) {
    this.isDeleteProposal = true;
    this.selectedProposal = proposal;
  }
  confirmDelete() {
    if (this.isDeleteProposal) {
      let schemeId = this.selectedProposal.id;
      const sub = this.apiService
        .deleteAPI(`/master/proposals/${schemeId}/`)
        .subscribe((res: any) => {
          // if (res) {
          this.isDeleteProposal = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Proposal Deleted Successfully',
          });
          // }
          this.getProposal();
        });
      this.subscriptions.add(sub);
    }
  }
  searchProposals(query: string) {
    this.searchProposalQuery = query?.toLowerCase() || '';
    this.lazy = true;
    this.getProposal(1);
  }

  clear(table: any, searchInput: HTMLInputElement): void {
    searchInput.value = '';
    this.searchProposalQuery = '';
    this.lazy = true;
    this.getProposal(1);
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'approved':
        return 'bg-success';
      case 'pending':
        return 'bg-warning text-dark';
      case 'short_closed':
        return 'bg-secondary';
      case 'rejected':
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }

  getFieldValue(obj: any, fieldPath: string): any {
    if (!obj || !fieldPath) {
      return null;
    }
    try {
      return fieldPath.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
          return acc[part];
        }
        return undefined;
      }, obj);
    } catch {
      return undefined;
    }
  }

  // Handle scheme status tab change
  onSchemeStatusTabChange(tab: any) {
    const tabIndex = tab.tab;
    this.activeStatusTabIndex = tab;

    if (tabIndex === 0) {
      // New Scheme tab - initialize form and load drafts
      this.initializeNewProposalForm();
      this.getDraftProposals();
    } else {
      // For other tabs, filter proposals by status
      this.getProposal(1);
    }
  }

  // Initialize form for new proposal
  initializeNewProposalForm() {
    this.proposalForm.reset();
    this.currentDraftNeedId = null; // Reset draft need ID
    this.currentDraftProposalId = null; // Reset draft proposal ID
    this.selectedDraftProposal = null; // Reset selected draft proposal
    this.selectedDmsFiles = []; // Reset uploaded files
    // Priority: selectedScheme > currentsubSchemeId > currentSchemeId
    const schemeId = this.selectedScheme?.id || parseInt(this.currentsubSchemeId) || parseInt(this.currentSchemeId);
    this.proposalForm.patchValue({
      scheme: schemeId
    });
    // Load schemes if not already loaded
    if (this.schemes.length === 0) {
      this.getSchemes();
    }
  }

  approveAPSO() {
    // Add your APSO approval logic here
  }

  // Draft proposal functionality
  draftProposals: any[] = [];

  getDraftProposals(id?: number) {
    // Use only the selected sub-scheme ID from /master/scheme/sub/details/
    // Don't fallback to currentSchemeId from query params
    const schemeId = this.currentsubSchemeId;

    // Only make API call if sub-scheme is selected
    if (!schemeId) {
      this.draftProposals = [];
      return;
    }

    let url = '/make1/save-draft/proposal/';
    url += `?scheme=${schemeId}`;

    this.apiService.getAPI(url).subscribe((res: any) => {
      // Filter to only show drafts for the current scheme
      if (Array.isArray(res)) {
        const filtered = res.filter((draft: any) =>
          draft.scheme === parseInt(schemeId) ||
          draft.scheme_id === parseInt(schemeId) ||
          draft.proposal?.scheme === parseInt(schemeId)
        );
        // Map the data to include proposal_name for table display
        this.draftProposals = filtered.map((draft: any) => ({
          ...draft,
          proposal_name: draft.proposal?.name || draft.proposal_name || draft.name || '-'
        }));
      } else {
        this.draftProposals = [];
      }
    }, (err: any) => {
      // If /make endpoint doesn't exist, try filtering from a common endpoint
      console.warn('Make draft endpoint not found, trying alternative');
      this.draftProposals = [];
    });
  }

  saveDrafttttt() {
    const v = this.proposalForm.value;
    const payload: any = {
      proposal: { name: v.proposalName, description: v.description, scheme: v.scheme },
      need: {
        nomenclature: v.nomenclature,
        brief_description: v.brief_description,
        // how_is_requirement_met_presently: v.how_is_requirement_met_presently,
        requirement_met: v.requirement_met,
        total_qty_req: v.qtyReqd,
        prototype_qty: v.qtyPrototype,
        bulk_qty: v.qtyBulk,
        development_prototype: v.development_prototype,
        development_cost: v.estimatedDevelopmentCost,
        unit_cost: v.estimatedUnitCost,
        lpp_cost: v.llp,
        bulk_cost: v.bulk_cost,
        poev: v.poev,
        lpp_year: v.lpyear,
        indigenously_designed: v.indigenously_designed,
        capability_infrastructure: v.capability_infrastructure,
        ltpp: v.ltpp,
        technical_details: v.technologyInsertion,
        justification: v.justificationText,
        // export_potential: v.exportPotential,
        lead_development: v.lead_development,
        indigenise_equipment: v.indigenise_equipment,
        rfi_indigenous: v.rfi_indigenous,
        collaboration_envisaged: v.collaboration_envisaged,
        drdo_psu: v.drdo_psu,
        technical_specifications: v.technical_specifications,
        operational_requirement: v.operational_requirement,
        drawings_manuals: v.drawings_manuals,
        sample_indigenisation: v.sample_indigenisation,
        annual_Acquisition: v.annual_Acquisition,
        trials_environments: v.trials_environments,
        photograph_item: v.photograph_item,
        export_potential: v.export_potential,
        project_similar: v.project_similar,
        approval_apso: v.approval_apso,
        nodal_officer_details: v.nodalOfficerDetails,
        critical_technology: v.critical_technology,
        drdo_infrastructure: v.drdo_infrastructure,
        trial_infrastructure: v.trial_infrastructure,
        // revenue_idex: v.revenue_idex,
      },
      action: this.proposalForm.get('id')?.value ? 'update' : 'create'
    };
    if (payload.action === 'update' && this.selectedDraftProposal) {
      payload.proposal.proposal_id = this.selectedDraftProposal.proposal_id;
      payload.need.need_id = this.selectedDraftProposal.id;
    }
    this.isSectionOpen.uploads = false;
    const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

    this.apiService.postAPI('/make1/save-draft/proposal/', fd).subscribe(
      (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Draft saved successfully.' });
        if (payload.action === 'update') this.selectedDraftProposal = null;
        this.selectedDmsFiles = [];
        this.isSectionOpen.uploads = true;
        this.getDraftProposals();
      },
      (err: any) => this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to save draft.' })
    );
  }
  saveDraft() {
    const v = this.proposalForm.value;
    const payload: any = {
      proposal: { name: v.proposalName, description: v.description, scheme: v.scheme },
      need: {
        seek_proposal: v.seek_proposal,
        nomenclature: v.nomenclature,
        brief_description: v.brief_description,
        // how_is_requirement_met_presently: v.how_is_requirement_met_presently,
        requirement_met: v.requirement_met,
        total_qty_req: v.qtyReqd,
        prototype_qty: v.qtyPrototype,
        bulk_qty: v.qtyBulk,
        development_prototype: v.development_prototype,
        development_cost: v.estimatedDevelopmentCost,
        dual_technology: v.dual_technology,
        unit_cost: v.estimatedUnitCost,
        lpp_cost: v.llp,
        bulk_cost: v.bulk_cost,
        exchequer: v.exchequer,
        poev: v.poev,
        lpp_year: v.lpyear,
        indigenously_designed: v.indigenously_designed,
        capability_infrastructure: v.capability_infrastructure,
        ltpp: v.ltpp,
        technical_details: v.technologyInsertion,
        justification: v.justificationText,
        // export_potential: v.exportPotential,
        lead_development: v.lead_development,
        indigenise_equipment: v.indigenise_equipment,
        rfi_indigenous: v.rfi_indigenous,
        collaboration_envisaged: v.collaboration_envisaged,
        drdo_psu: v.drdo_psu,
        technical_specifications: v.technical_specifications,
        operational_requirement: v.operational_requirement,
        drawings_manuals: v.drawings_manuals,
        sample_indigenisation: v.sample_indigenisation,
        annual_Acquisition: v.annual_Acquisition,
        trials_environments: v.trials_environments,
        photograph_item: v.photograph_item,
        export_potential: v.export_potential,
        project_similar: v.project_similar,
        revenue_idex: v.revenue_idex,
        approval_apso: v.approval_apso,
        nodal_officer_details: v.nodalOfficerDetails,
        critical_technology: v.critical_technology,
        drdo_infrastructure: v.drdo_infrastructure,
        trial_infrastructure: v.trial_infrastructure,
        vinatge_oem: v.vinatge_oem,
        // revenue_idex: v.revenue_idex,
      },
      action: this.proposalForm.get('id')?.value ? 'update' : 'create'
    };
    if (payload.action === 'update' && this.selectedDraftProposal) {
      payload.proposal.proposal_id = this.selectedDraftProposal.proposal_id;
      payload.need.need_id = this.selectedDraftProposal.id;
    }
    const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

    this.apiService.postAPI('/make1/save-draft/proposal/', fd).subscribe(
      (res: any) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message || 'Draft saved successfully.' });
        this.getDraftProposals(res.id);
      },
      (err: any) => this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to save draft.' })
    );
  }

  populateDraftProposal(draft: any) {
    // Store the need_id from the draft data (draft.id is the need_id)
    this.currentDraftNeedId = draft.id || draft.need_id || null;
    // Store the proposal_id from the draft data
    this.currentDraftProposalId = draft.proposal_id || null;
    // Store the selected draft proposal with dms_files
    this.selectedDraftProposal = draft;

    // Convert lpp_year string to Date object if it exists
    let lpyearValue = null;
    if (draft.lpp_year) {
      lpyearValue = new Date(draft.lpp_year);
    } else if (draft.lpyear) {
      lpyearValue = draft.lpyear instanceof Date ? draft.lpyear : new Date(draft.lpyear);
    }

    this.proposalForm.patchValue({
      id: draft.id,
      seek_proposal: draft?.seek_proposal ?? false,
      proposalName: draft.proposal_name || draft.nomenclature || draft.proposalName || draft.name,
      description: draft.description,
      scheme: draft.scheme?.id || draft.scheme_id || parseInt(this.currentsubSchemeId) || parseInt(this.currentSchemeId),
      nomenclature: draft.nomenclature || 'Secure Horizon Make 1 Nomenclature',
      brief_description: draft.brief_description || '',
      // how_is_requirement_met_presently: draft.how_is_requirement_met_presently || '',
      requirement_met: draft.requirement_met || '',
      qtyReqd: draft.total_qty_req || draft.qtyReqd || '',
      qtyPrototype: draft.prototype_qty || draft.qtyPrototype || '',
      qtyBulk: draft.bulk_qty || draft.qtyBulk || '',
      development_prototype: draft.development_prototype || '',
      estimatedDevelopmentCost: draft.development_cost || draft.estimatedDevelopmentCost || '',
      estimatedUnitCost: draft.unit_cost || draft.estimatedUnitCost || '',
      llp: draft.lpp_cost || draft.llp || '',
      dual_technology: draft.dual_technology,
      bulk_cost: draft.bulk_cost || '',
      exchequer: draft.exchequer,
      poev: draft.poev || '',
      lpyear: lpyearValue,
      indigenously_designed: draft.indigenously_designed || '',
      capability_infrastructure: draft.capability_infrastructure || '',
      ltpp: draft.ltpp || '',
      technologyInsertion: draft.technical_details || draft.technologyInsertion || '',
      justificationText: draft.justification || draft.justificationText || '',
      exportPotential: draft.export_potential || draft.exportPotential || '',
      lead_development: draft.lead_development || '',
      indigenise_equipment: draft.indigenise_equipment || '',
      rfi_indigenous: draft.rfi_indigenous || '',
      collaboration_envisaged: draft.collaboration_envisaged || '',
      drdo_psu: draft.drdo_psu || '',
      technical_specifications: draft.technical_specifications || '',
      operational_requirement: draft.operational_requirement || draft.operational_requirement || '',
      drawings_manuals: draft.drawings_manuals || '',
      sample_indigenisation: draft.sample_indigenisation || '',
      annual_Acquisition: draft.annual_Acquisition || draft.annual_Acquisition || '',
      trials_environments: draft.trials_environments || '',
      photograph_item: draft.photograph_item || '',
      export_potential: draft.export_potential || draft.export_potential || '',
      project_similar: draft.project_similar || '',
      revenue_idex: draft.revenue_idex || '',
      approval_apso: draft.approval_apso || '',
      nodalOfficerDetails: draft.nodal_officer_details || draft.nodalOfficerDetails || '',
      critical_technology: draft.critical_technology || '',
      drdo_infrastructure: draft.drdo_infrastructure || '',
      trial_infrastructure: draft.trial_infrastructure || '',
      vinatge_oem: draft.vinatge_oem || '',
      // revenue_idex: draft.revenue_idex || ''
    });
  }

  initStepperItems() {
    this.items = [
      { label: 'Add Proposal', command: () => (this.activeIndex = 0) },
    ];

    if (this.isUpdateProposal) {
      this.items.push({
        label: 'Skip Stages',
        command: () => (this.activeIndex = this.items.length),
      });
    }

    this.items.push({
      label: 'Route Configuration',
      command: () => {
        this.apiCallForTransaction();
        this.activeIndex = this.items.length - 1;
      },
    });
  }
  updateProposal(proposal: any) {
    this.selectedProposal = proposal;  // Store selected proposal
    this.isUpdateProposal = true;
    this.addProposalVisible = true;
    this.activeIndex = 0;
    this.proposalForm.patchValue({
      proposalName: proposal.name,
      scheme: proposal.scheme.id,
      // fund: proposal.fund,
      description: proposal.description
    });

    // Make sure the scheme dropdown correctly displays the name
    this.populateScheme(proposal.scheme);
    this.getSchemes();
    // this.getFunds();
    this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    // Important: Disable scheme control manually
    this.proposalForm.get('scheme')?.disable();
    this.initStepperItems();

  }
  populateScheme(schemeId: number) {
    const selectedScheme = this.schemes.find(s => s.id === schemeId);
    if (selectedScheme) {
      this.proposalForm.patchValue({ scheme: selectedScheme.id });
    }
  }
  getStages(schemeId: any, pass: any) {
    if (this.isUpdateProposal && pass == 'pass') {
      const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?phase_id=${this.activePhaseId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.master_step,
          step_mapping: item.step_mapping,
          name: item.name,
          sequence: item.sequence,
          skipped: item.skipped,
          code: item.code,
          remark: item.remark,
          isSelected: item.isSelected,
          week_timeline: item.week_timeline,
          percentage: item.percentage
        }));
        this.calculateCompletionSum()
        if (res.length < 1) {
          this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`)
            .subscribe((res: any) => {
              this.stages = res.map((item: any) => ({
                // master_step: item.step.id,
                step_mapping: item?.id,
                name: item.step.name,
                sequence: item.sequence,
                skipped: item.step.code == 'R-POC' ? true : false,
                code: item.step.code,
                week_timeline: item.week_timeline,
                percentage: item.percentage,
                remark: '',
                isSelected: false
              }));
              this.calculateCompletionSum()
              this.confirmSkipStage()
            });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.apiService.getAPI(`/master/scheme-step/mapping/?scheme=${schemeId}`).subscribe((res: any) => {
        this.stages = res.map((item: any) => ({
          // master_step: item.step.id,
          step_mapping: item.id,
          name: item.step.name,
          sequence: item.sequence,
          skipped: item.step.code == 'R-POC' ? true : false,
          code: item.step.code,
          remark: '',
          week_timeline: item.week_timeline,
          percentage: item.percentage,
          isSelected: false
        }));
        // this.calculateCompletionSum()
        this.confirmSkipStage();
      });
      this.subscriptions.add(sub);
    }
  }
  calculateCompletionSum(): void {
    this.completionSum = this.stages
      .filter(stage => !stage.skipped)
      .reduce((sum, stage) => sum + Number(stage.percentage || 0), 0);
    this.completionSum = this.completionSum.toFixed(2)
  }
  confirmSkipStage() {
    // Guard: Check if selectedProposal and id exist
    if (!this.selectedProposal || !this.selectedProposal.id) {
      console.error('Cannot submit steps: selectedProposal or id is missing', this.selectedProposal);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Proposal ID is missing. Please try again.'
      });
      return;
    }

    const updatedStages = this.stages.map(stage => {
      const isSkipped = stage.code === 'R-POC' ? true : stage.skipped || false;

      // Create a shallow copy and modify it
      const { week_timeline, percentage, ...rest } = stage;

      return {
        ...rest,
        skipped: isSkipped,
        week_timeline: week_timeline || null,
        percentage: percentage || null,
      };
    });

    const sub = this.apiService.postAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/`, updatedStages).subscribe((res: any) => {
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Stages Skipped Successfully' });
      if (res.length > 0 && this.isUpdateProposal) {
        this.apiCallForTransaction();
      }
      if (res.message == 'Steps processed successfully' && !this.isUpdateProposal) {
        // this.getStages(this.selectedScheme.id,'pass');
        this.onrouteFormSubmit()
      }
      // this.getProposal();
      const routeIndex = this.items.findIndex(i => i.label === 'Route Configuration');
      if (routeIndex !== -1) {
        // this.activeIndex = routeIndex;
      }
    });
    this.subscriptions.add(sub);

  }
  apiCallForTransaction() {
    // Guard: Check if selectedProposal and id exist
    if (!this.selectedProposal || !this.selectedProposal.id) {
      console.error('Cannot fetch transaction: selectedProposal or id is missing', this.selectedProposal);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Proposal ID is missing. Please try again.'
      });
      return;
    }

    // this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
    this.getUnit()
    this.getRoleList();
    this.getUserList();
    const sub = this.apiService.getAPI(`/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`).subscribe((res: any) => {
      this.stagesList = res
      // if (this.currentUserRoleId == '6') {
      //   // Role 6 gets full list
      //   this.stagesList = res;
      // } else {
      //   // Other roles only get the first stage
      //   this.stagesList = res.length ? [res[0]] : [];
      // }
      this.filteredStagesList = this.stagesList.filter(step => !step.skipped);
      this.routeForm.get('step')?.setValue(this.stagesList[0].id);
      if (this.addMode == 'new' && !this.isUpdateProposal) {
        let unit = sessionStorage.getItem('unit_id')
        let user = sessionStorage.getItem('user_id')
        this.userID = Number(user);
        this.roleID = this.roleList[0]?.id;
        // this.routeForm.get('unit')?.patchValue(Number(unit));
        // this.routeForm.get('user')?.patchValue(Number(user));
        // this.routeForm.get('role')?.patchValue(this.roleList[0]?.id);
      }
      this.stepId = this.stagesList[0].id
      this.tryFetchingSequence();
      this.getProposalWorkflow(this.stagesList[0].id);
    });
    this.subscriptions.add(sub);

  }
  getUnit() {
    const sub = this.apiService
      .getAPI('/master/units/')
      .subscribe((res: any) => {
        this.unitList = res.data;
      });
    this.subscriptions.add(sub);
  }
  getRoleList() {
    const sub = this.apiService
      .getAPI('/access/user-roles/')
      .subscribe((res: any) => {
        const rolePriority = ['INT', 'REC', 'APP']; // desired order
        const resp = res.data;
        this.roleList = resp
          .filter((role) => rolePriority.includes(role.code))
          .sort(
            (a, b) =>
              rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
          );
      });
  }
  // getUserList() {
  //   const sub = this.apiService
  //     .getAPI('/account/users/')
  //     .subscribe((res: any) => {
  //       // const allUsers = res.data;
  //       // const filteredUsers = allUsers.filter(
  //       //   (user: any) => !(user.roles && user.roles[0].code === 'ADMIN')
  //       // );
  //       this.userList = res.data;
  //       this.userListCopy = [...this.userList];
  //     });
  // }

  getUserList() {
    const unitId = Number(sessionStorage.getItem('unit_id'));
    const sub = this.apiService.getAPI('/account/users/').subscribe((res: any) => {
      let user = res.data;
      this.userList = user.filter((user: any) => {
        return user.unit?.id === unitId;
      });
    });

    this.subscriptions.add(sub);
  }

  onRoleChange(event: any) {
    this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    this.userID = event.value;
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value;
    this.userList = this.userListCopy.filter(
      (user) => user.unit?.id == unit_id
    );
  }
  onrouteFormSubmit() {
    // Guard: Check if selectedProposal and id exist
    if (!this.selectedProposal || !this.selectedProposal.id) {
      console.error('Cannot submit route: selectedProposal or id is missing', this.selectedProposal);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Proposal ID is missing. Please try again.'
      });
      return;
    }

    const formValue = this.routeForm.value;
    const unit = Number(sessionStorage.getItem('unit_id'));
    const user = Number(sessionStorage.getItem('user_id'));

    if (!formValue.approved) {
      if (!this.isUpdateProposal) {
        this.apiService.getAPI(
          `/transaction/proposals/${this.selectedProposal.id}/steps/?skipped=False&phase_id=${this.activePhaseId}`
        ).subscribe({
          next: (res: any) => {
            const stepid = res?.[0]?.id;
            if (!stepid) {
              console.error("No step found for proposal.");
              return;
            }

            // ✅ Fetch roles and then continue
            this.apiService.getAPI('/access/user-roles/').subscribe((rolesRes: any) => {
              const rolePriority = ['INT', 'REC', 'APP'];
              this.roleList = rolesRes.data
                .filter((role: any) => rolePriority.includes(role.code))
                .sort(
                  (a: any, b: any) =>
                    rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code)
                );

              if (!this.roleList.length) {
                console.error("No roles found.");
                return;
              }

              const payload = {
                status: 1,
                sequence: 0,
                proposal_step: stepid,
                user,
                unit,
                role: this.roleList[0].id, // ✅ role is now defined
                is_final_approve: formValue.approved || false
              };

              this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
                next: (res: any) => {
                  this.routeForm.reset();

                  if (!this.isUpdateProposal) {
                    sessionStorage.setItem('user_role_id', this.roleList[0].id);
                    sessionStorage.setItem('user_role_name', this.roleList[0].name);
                    this.messageService.add({
                      severity: 'success',
                      summary: 'Success',
                      detail: `Role has now been changed to ${this.roleList[0].name}.`
                    })
                    this.getPermissions();
                    this.addProposalVisible = false;
                    this.navigateToSchemeTransaction(this.proposalData[0], this.activePhaseId);
                  }
                },
                error: (err) => {
                  console.error("Workflow API error:", err);
                }
              });
            });
          },
          error: (err) => {
            console.error("Step API error:", err);
          }
        });

      } else {
        // Update proposal case
        const payload = {
          status: 1,
          sequence: this.routeForm.get('level')?.value,
          proposal_step: formValue.step,
          user: formValue.user,
          role: formValue.role,
          unit: formValue.unit,
          is_final_approve: formValue.approved || false
        };
        this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
          next: (res: any) => {
            this.routeForm.reset();
            this.getProposalWorkflow(formValue.step)
          },
          error: (err) => {
            console.error("Workflow API error:", err);
          }
        });
      }
    } else {
      // Approved case
      const payload = {
        proposal_step: formValue.step,
        user: formValue.user,
        unit: formValue.unit,
        role: this.roleList?.[2]?.id,
        is_final_approve: true
      };
      this.apiService.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
        next: (res: any) => {
          this.routeForm.reset();
          this.getProposalWorkflow(formValue.step)
        },
        error: (err) => {
          console.error("Workflow API error:", err);
        }
      });
    }
  }
  getPermissions() {
    let role_id = sessionStorage.getItem('user_role_id')
    this.apiService
      .getAPI(
        `/access/get-permissions/?role_id=${role_id}`
      )
      .subscribe((res: any) => {
        this.permissionService.setPermissions(res);
      });
  }
  setActiveIndex(index: number): void {
    this.activeIndex = index;
    // this.apiCallForTransaction()

    // Handle role-specific actions
    if (this.currentUserRoleId == '6') {
      if (index === 1) { // Route Configuration for role 6
        this.apiCallForTransaction();
      }
    } else {
      if (index === 1) { // Route Configuration for other roles
        this.apiCallForTransaction();
      }
    }
  }
  getDialogHeader(): string {
    if (this.isUpdateProposal) {
      return 'Update Proposal';
      // : `Update Proposal on ${this.activeTabName}`;
    } else {
      return this.addMode === 'new'
        ? 'Add New Proposal'
        : `Add Proposal to ${this.activeTabName}`;
    }
  }
  getSchemewisePhase(scheme_id?: number) {
    this.currentsubSchemeId = scheme_id

    const sub = this.apiService.getAPI(`/master/scheme/${scheme_id}/phases/`).subscribe((res) => {
      // this.phases = res
      // ✅ Define custom order
      const order = [
        "Initiation & Approval",
        "Project Sanction",
        "Prototype Development & Evaluation",
        "Procurement"
      ];

      // ✅ Sort response according to custom order
      this.phases = res.sort(
        (a: any, b: any) => order.indexOf(a.name) - order.indexOf(b.name)
      );
      this.selectedPhaseId = this.phases[0]?.id;
      this.activePhaseId = this.phases[0]?.id
      this.getProposal(1);

      // Load draft proposals when sub-scheme is selected and on "New Scheme" tab
      if (this.activeStatusTabIndex?.tab === 0) {
        this.getDraftProposals();
      }
    });
    this.subscriptions.add(sub);
  }
  navigateToSchemeTransaction(schemeName: any, phaseId: any) {
     const isShortClose = schemeName.proposal_status === 'short_close' || schemeName.proposal_status === 'approved';

    if (schemeName.scheme.name == 'Make I') {
      console.log(" Make I", schemeName, schemeName.scheme.name);
      this.router.navigate(['/make-i-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id, short_close: isShortClose }
      });
    } else if (schemeName.scheme.name == 'Make II') {
      console.log("Navigating to Make II", schemeName, schemeName.scheme.name);
      this.router.navigate(['/make-ii-transaction'], {
        queryParams: {
          id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id, short_close: isShortClose
        }
      });
    } else {
      this.router.navigate(['/make-iii-transaction'], {
        queryParams: { id: schemeName.id, name: schemeName.name, scheme: schemeName.scheme.id, phase: phaseId, step: schemeName.step_summary.current_step_id, short_close: isShortClose }
      });
    }

  }
  navigateToScheme(schemeName: any) {
    this.schemeService.setScheme(schemeName);
    this.router.navigate(['/proposal-dashboard'], {
      queryParams: {
        scheme: schemeName.name,
        id: schemeName.id,
        phase: this.activePhaseId,
      },
    });
  }
  next() {
    this.activeIndex += 1;
    this.getProposal();
  }
  onStepChange(event: any) {
    this.stepId = event.value;
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${event.value}`)
      .subscribe((res: any) => {
        this.RouteUserList = res.data;
        if (res.data[0]) {
          this.routeForm
            .get('approved')
            .patchValue(res.data[0]?.is_final_approve || false);
        } else {
          this.routeForm.get('approved').patchValue(false);
        }
      });
    this.subscriptions.add(sub);
    this.tryFetchingSequence();
  }
  onAllRolesSame(isSame: boolean) {
    const userId = sessionStorage.getItem('user_id');

    if (userId) {
      const matchedUser = this.userList.find((user) => user.id == userId);

      if (matchedUser) {
        if (isSame) {
          this.routeForm.patchValue({
            unit: matchedUser.unit.id,
            user: matchedUser.id,
          });
        } else {
          // Optionally reset the fields
          this.routeForm.patchValue({
            unit: null,
            user: null,
          });
        }
      } else {
        console.warn('User ID not found in users list.');
      }
    } else {
      console.warn('User ID not found in session storage.');
    }
  }
  tryFetchingSequence() {
    if (this.stepId && this.roleID && this.userID) {
      this.getSequence();
    }
  }

  getSequence() {
    const sub = this.apiService
      .getAPI(
        `/transaction/get-next-level/?proposal_step_id=${this.stepId}&role_id=${this.roleID}`
      )
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
      });
    this.subscriptions.add(sub);
  }
  deleteUser(user: any) {
    const sub = this.apiService
      .deleteAPI(`/transaction/proposal-workflow/${user.id}/`)
      .subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'User deleted successfully.',
        });
        this.getProposalWorkflow(user.proposal_step.id);
      });
    this.subscriptions.add(sub);
  }
  getProposalWorkflow(id: any) {
    this.RouteUserList = [];
    const sub = this.apiService
      .getAPI(`/transaction/proposal-workflow/?proposal_step_id=${id}`)
      .subscribe((res: any) => {
        // this.RouteUserList = res.data;
        const allData = res.data || [];

        // Filter only users with role.code 'INT', 'APP', or 'REC'
        this.RouteUserList = allData.filter(
          (user: any) =>
            ['INT', 'APP', 'REC'].includes(user.role.code) ||
            user.is_final_approve
        );
      });
    this.subscriptions.add(sub);
  }


  /* New design */
  showTab(tab: any) {
    this.activeTab = tab;

    if (this.activeTab == 'initiation') {
      this.gettableData();
    }
  }
  toggleSelectAll() {
    // this.filteredProposals.forEach(p => (p.selected = this.selectAll));
    this.filteredProposals.forEach((proposal) => {
      proposal.selected = this.selectAll;
    });

    if (this.selectAll) {
      this.selectedChallengeCount = [...this.filteredProposals];
    } else {
      this.selectedChallengeCount = [];
    }
  }
  onChallengeSelectChange(proposal: any) {
    if (proposal.selected) {
      // Add if not already in list
      if (!this.selectedChallengeCount.some((ch) => ch.id === proposal.id)) {
        this.selectedChallengeCount.push(proposal);
      }
    } else {
      // Remove if unchecked
      this.selectedChallengeCount = this.selectedChallengeCount.filter(
        (ch) => ch.id !== proposal.id
      );
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.currentAction == 'edit') {
        this.challengeForm?.enable();
      } else {
        this.challengeForm?.disable();
      }
      //  this.rebuildEditor();
    }, 3000);
  }
  editorReady = true;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit(); // reapply config
      this.editorReady = true; // rebuild editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      plugins:
        'advlist anchor fullscreen insertdatetime autolink link lists image code advcode mergetags wordcount ai a11ychecker advcode advtemplate advlist advtable anchor autocorrect autosave editimage image link linkchecker lists markdown media mediaembed pageembed powerpaste searchreplace table template tinymcespellchecker typography visualblocks wordcount',
      toolbar:
        'undo redo fullscreen | styles fontsizeinput lineheight |insertdatetime  bold italic strikethrough backcolor forecolor visualblocks | align bullist numlist outdent indent | advlist  table link image media pageembed | spellcheckdialog a11ycheck code | searchreplace',
      readonly: this.currentAction === 'view',
    };
  }
  switchRole(role: string) {
    this.currentRole = role;
    this.applyFilters();
  }

  applyFilters() {
    let filtered = [...this.proposals];

    // Step 1: Category filter (from dropdown)
    if (this.filters.category) {
      filtered = filtered.filter((p) => p.category === this.filters.category);
    }

    // Step 2: Role filter (restrict based on role)
    // if (this.currentRole === 'doi') {
    //   filtered = filtered.filter(p => ['To Move', 'To Float'].includes(p.category));
    // } else if (this.currentRole === 'tdac') {
    //   filtered = filtered.filter(p => p.category === 'To Fight');
    // }

    // Step 3: Priority filter
    if (this.filters.priority) {
      filtered = filtered.filter((p) => p.priority === this.filters.priority);
    }
    if (this.filters.valuation) {
      filtered = filtered.filter((p) => p.valuation === this.filters.valuation);
    }
    // Step 4: Status filter (if needed)
    if (this.filters.status) {
      // filtered = filtered.filter(p => p.status === this.filters.status);
    }

    this.filteredProposals = filtered;
    this.updateStats();
  }

  updateStats() {
    this.stats.total = this.filteredProposals.length;
    // this.stats.pending = this.filteredProposals.filter(p => p.status === 'pending').length;
    // this.stats.screening = this.filteredProposals.filter(p => p.status === 'screening').length;
    // this.stats.approved = this.filteredProposals.filter(p => p.status === 'approved').length;
  }

  updateCategory(id: any, category: string) {
    const p = this.proposals.find((x) => x.id == id);
    if (p) p.category = category;
    this.applyFilters(); // optional: refresh view/stats if you rely on filteredProposals
  }

  updatePriority(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }
  updateValuation(id: any, priority: string) {
    // const proposal = this.proposals.find(p => p.id === id);
    // if (proposal) proposal.priority = priority;
  }


  bulkAction(action: string) {
    // const selected = this.filteredProposals.filter(p => p.selected);
    // if (!selected.length) {
    //   alert('Please select at least one proposal.');
    //   return;
    // }
    // alert(`${action.toUpperCase()} applied on: ${selected.map(p => p.id).join(', ')}`);
  }

  viewDetailsN(proposal: Proposal, mode: 'view') {
    this.selectedProposal = proposal;
    this.detailsModalOpen = true;
    this.currentAction = mode;
    this.isEditMode = false;
    this.rebuildEditor();
    this.challengeForm.disable();
    this.challengeForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
  }
  savetableData(proposal: Proposal) {
    this.challengeForm.reset();
    this.selectedProposal = proposal;
    this.challengeForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      priority: proposal.priority,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,

      // valuation:proposal.valuation, // fields for DIO
      challenge_status: proposal.challenge_status,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
    this.onSubmit();
  }

  closeDetailsModal() {
    this.detailsModalOpen = false;
    this.selectedProposal = null;
  }

  editProposal(proposal: Proposal, mode: 'edit') {
    this.currentAction = mode;
    this.rebuildEditor();
    this.isEditMode = true;
    this.challengeForm.enable();

    this.selectedProposal = { ...proposal };
    this.challengeForm.reset();
    this.challengeForm.patchValue({
      organisation: proposal.organisation,
      category: proposal.category,
      releaseDate: proposal.release_date,
      approvedBy: proposal.approved_by,
      coordinatingAgency: proposal.coordinated_agency,
      technologyDomain: proposal.technology_domain,
      challenge_status: proposal.challenge_status,
      ip_status: proposal.ip_status,

      challengeTitle: proposal.title,
      nodalOfficer: proposal.nodal_officer,
      problemStatement: proposal.problem_statement,
      challengeBrief: proposal.challenge_brief,
      prototypeDevelopment: proposal.prototype_development,
      requirement: proposal.requirement,
      ipValue: proposal.ip_value,
      functionalAdvantages: proposal.functional_advantages,
      domestic: proposal.domestic,
      substitution: proposal.substitution,
      preliminaryScope: proposal.preliminary_scope,
      competitiveSolution: proposal.competitive_solution,
      potentialMarket: proposal.potential_market,
      riskAssessment: proposal.risk_assessment,
      mpoQty: proposal.mpo_qty,
    });
    this.detailsModalOpen = true;
  }
  gettableData() {
    this.apiService
      .getAPI(`/idex/dashboard/challenge/list/?role_id=${this.userID}`)
      .subscribe({
        next: (res: any[]) => {
          this.proposals = res;
          this.filteredProposals = [...this.proposals];
        },
      });
  }
  onFileSelect(event: any, type: string) {
    const files: File[] = event.files;

    if (type === 'draftSotr') {
      this.draftSotrFile = files[0]; // Only one file expected
    } else if (type === 'supportingDocs') {
      // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
      this.supportingDocsFiles = files[0];
    }
  }

  onUploadDraftSotr(event: any) {
    const file: File = event.files[0];
    if (file) {
      this.draftSotrFile = file;
      this.messageService.add({
        severity: 'success',
        summary: 'File attached successfully',
        detail: file.name,
      });
    }
  }

  onUploadSupportingDocs(event: any) {
    // const files: File[] = event.files;
    const file: File = event.files[0];
    if (file) {
      this.supportingDocsFiles = file;
    }
    // this.supportingDocsFiles = [...this.supportingDocsFiles, ...files];
    this.messageService.add({
      severity: 'success',
      summary: 'Supporting Documents Uploaded',
      detail: ` files uploaded`,
    });
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  onSubmitch() {
    let formData = new FormData();

    formData.append(
      'organisation',
      this.challengeForm.get('organisation').value
    );
    formData.append('category', this.challengeForm.get('category')?.value);
    formData.append('priority', this.challengeForm.get('priority')?.value);
    formData.append(
      'ip_status',
      this.challengeForm.get('valuation')?.value || ''
    );
    formData.append(
      'challenge_status',
      this.challengeForm.get('challenge_status')?.value || ''
    );
    formData.append(
      'release_date',
      this.challengeForm.get('releaseDate').value
    );
    if (this.challengeForm.get('approvedBy').value != null) {
      formData.append(
        'approved_by',
        this.challengeForm.get('approvedBy').value
      );
    }
    formData.append(
      'coordinated_agency',
      this.challengeForm.get('coordinatingAgency').value
    );
    formData.append(
      'technology_domain',
      this.challengeForm.get('technologyDomain').value
    );

    formData.append('title', this.challengeForm.get('challengeTitle').value);
    formData.append(
      'nodal_officer',
      this.challengeForm.get('nodalOfficer').value
    );
    formData.append(
      'problem_statement',
      this.challengeForm.get('problemStatement').value
    );
    formData.append(
      'challenge_brief',
      this.challengeForm.get('challengeBrief').value
    );
    formData.append(
      'prototype_development',
      this.challengeForm.get('prototypeDevelopment').value
    );
    formData.append('requirement', this.challengeForm.get('requirement').value);
    formData.append('ip_value', this.challengeForm.get('ipValue').value);
    formData.append(
      'functional_advantages',
      this.challengeForm.get('functionalAdvantages').value
    );
    formData.append('domestic', this.challengeForm.get('domestic').value);
    formData.append(
      'substitution',
      this.challengeForm.get('substitution').value
    );
    formData.append(
      'preliminary_scope',
      this.challengeForm.get('preliminaryScope').value
    );
    formData.append(
      'competitive_solution',
      this.challengeForm.get('competitiveSolution').value
    );
    formData.append(
      'potential_market',
      this.challengeForm.get('potentialMarket').value
    );
    formData.append(
      'risk_assessment',
      this.challengeForm.get('riskAssessment').value
    );
    formData.append('mpo_qty', this.challengeForm.get('mpoQty').value);

    if (this.draftSotrFile) {
      formData.append('pds', this.draftSotrFile);
    }

    if (this.supportingDocsFiles) {
      // this.supportingDocsFiles.forEach(file => {
      formData.append('pru', this.supportingDocsFiles); // Change key name if needed
      // });
    }
    let url = `/idex/challenges/${this.selectedProposal.id}/`;

    const sub = this.apiService.putAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Challenge Updated successfully',
        });
        this.gettableData();
        this.fileUpload.clear();
        this.draftSotrUpload.clear();
      },
      error: (err) => { },
    });
    this.subscriptions.add(sub);
  }
  routeModal: boolean = false;
  openRouteModal() {
    // alert('Open route configuration modal here.');
    this.routeModal = true;
    this.selectedChallenges = this.proposals.filter((p) => p.selected);
    this.getRoleList();
    this.getUserList();
    this.getUnit();
    if (this.selectedChallenges.length > 0) {
      this.routeModal = true;
    }
  }



  submitIRA() {
    let role_id = sessionStorage.getItem('user_role_id');
    const payload = this.selectedChallenges.map((challenge, index) => ({
      proposal_step: challenge.current_proposal_step,
      role_id: Number(role_id),
      is_approved: true,
      remark: this.IRAremarks,
    }));
    this.IRAremarks = '';
    const sub = this.apiService
      .postAPI(`/idex/bulk/proposal-ira-action/`, payload)
      .subscribe((res: any) => {
        this.isEditable = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Proposal added successfully',
        });
      });
    this.subscriptions.add(sub);
  }
  updatelaunchStatus(id: any, priority: string) { }

  selectedPhaseProposals: any[] = [];

  onPhaseChange(index: number) {
    this.activeTabIndex = index;
    this.selectedPhaseProposals = this.getProposalsByPhase(this.phases[index].id);
  }

  getProposalsByPhase(phaseId: number) {
    return this.proposalData.filter(p => p.phase_id == phaseId);
  }

  // Scheme status tabs
  schemeStatusTabs = [
    { label: 'Draft Proposals', status: 'form', active: true, tab: 0 }, // Special status for form
    { label: 'Pre APSO Approval', status: 'initiated', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Ongoing (APSO Approved)', status: 'apso_approve', active: false, tab: 1 }, // Show initiated proposals
    { label: 'Ongoing (VCNS Approved)', status: 'in_review', active: false, tab: 1 },
    { label: 'Completed Proposal', status: 'approved', active: false, tab: 1 },
    { label: 'Short Closed Proposal', status: 'short_close', active: false, tab: 1 },
    { label: 'Rejected Proposal', status: 'rejected', active: false, tab: 1 },
  ];
  activeStatusTabIndex: any = this.schemeStatusTabs[0];

  // Table properties for new UI
  tableColumns = [
    { field: 'actions', header: 'Actions', filterType: 'text', filter: false },
    { field: 'checkbox', header: '', filterType: 'text', filter: false },
    { field: 'directorate', header: 'Directorate', filterType: 'text', filter: true },
    { field: 'name', header: 'Name', filterType: 'text', filter: true },
    { field: 'description', header: 'Description', filterType: 'text', filter: true },
    { field: 'steps', header: 'Steps', filterType: 'text', filter: false },
    { field: 'progress', header: 'Progress', filterType: 'text', filter: true },
    { field: 'proposal_status', header: 'Status', filterType: 'text', filter: true }
  ];
  selectedProposals: any[] = [];
  lazy: boolean = true;
  totalCount: number = 10;
  currentDraftNeedId: number | null = null; // Store the need_id from draft
  currentDraftProposalId: number | null = null; // Store the proposal_id from draft
  selectedDraftProposal: any; // Store the selected draft proposal with dms_files
  selectedDmsFiles: any[] = []; // Store uploaded file data
  @ViewChild('dt') table: Table;

  anyCompletionEntered = false;
  allCompletionFilled = false;

  onCompletionChange() {
    const completions = this.stages.map((s) => s.percentage);
    const enteredValues = completions.filter(
      (c) => c !== null && c !== undefined && c !== ''
    );
    const sum = enteredValues.reduce((acc, val) => acc + Number(val), 0);

    this.completionSum = sum;

    // Check if any completion is filled
    this.anyCompletionEntered = enteredValues.length > 0;

    // Check if all are filled when any is entered
    this.allCompletionFilled = completions.every(
      (c) => c !== null && c !== undefined && c !== ''
    );

    // You can use these flags to enable/disable submit button or show validation errors
  }
  canSubmit(): boolean {
    const relevantStages = this.stages.filter((stage) => !stage.skipped);

    const completions = relevantStages.map((stage) => stage.percentage);
    const anyEntered = completions.some(
      (value) => value != null && value !== ''
    );
    const allFilled = completions.every(
      (value) => value != null && value !== ''
    );
    const totalSum = completions.reduce((sum, val) => sum + (+val || 0), 0);

    // If none entered — allow submit
    if (!anyEntered) return true;

    // If some filled, only allow if all are filled and total ≤ 100
    return allFilled && totalSum <= 100;
  }
  isSectionOpen = {
    draftProposals: false,
    basicInfo: true,
    nomenclature: true,
    requirementIndigenise: true,
    estimatedCost: true,
    dualUse: true,
    quantity: true,
    cost: true,
    detailed: true,
    uploads: true,
    justification: true,
    reports: true,
    manufacture:true,

  };

  toggleSection(section: keyof typeof this.isSectionOpen): void {
    this.isSectionOpen[section] = !this.isSectionOpen[section];
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }

  // Check if all mandatory fields are filled
  areMandatoryFieldsFilled(): boolean {
    if (!this.proposalForm) {
      return false;
    }
    return (
      this.proposalForm.get('proposalName')?.valid &&
      this.proposalForm.get('scheme')?.valid &&
      this.proposalForm.get('nomenclature')?.valid &&
      this.proposalForm.get('qtyReqd')?.valid &&
      this.proposalForm.get('qtyPrototype')?.valid &&
      this.proposalForm.get('qtyBulk')?.valid
    );
  }

  // Route Configuration - Share Proposal Dialog
  shareType: string;
  permissionType: string;
  selectedUser: any; // For single selection (edit)
  selectedUsers: any[] = []; // For multiple selection (view/comment)
  selectedUnit: any; // For single selection (edit)
  selectedUnits: any[] = []; // For multiple selection (view/comment)

  displayDialogN = false;
  selectedUserN: any;
  internalComment: string;
  externalComment: string;

  openDialog() {
    this.displayDialogN = true;
    this.getUserList();
    this.getUnit();
  }

  onNeedformSubmit(event: any) {
    const formValues = this.proposalForm.value;
    const routePayload: any = {
      remark: event.internalComment,
      is_external: event.shareType === 'external',
    };
    if (event.shareType === 'external') {
      routePayload.unit_id = event.selectedUnit?.id;
      routePayload.command = event.selectedCommand;
    } else {
      routePayload.user = event.selectedUser?.id;
    }
    const payload = {
      proposal: {
        name: formValues.proposalName,
        description: formValues.description,
        scheme: formValues.scheme
      },
      need: {
        seek_proposal: formValues.seek_proposal,
        nomenclature: formValues.nomenclature,
        brief_description: formValues.brief_description,
        // how_is_requirement_met_presently: formValues.how_is_requirement_met_presently,
        requirement_met: formValues.requirement_met,
        total_qty_req: formValues.qtyReqd,
        prototype_qty: formValues.qtyPrototype,
        bulk_qty: formValues.qtyBulk,
        development_prototype: formValues.development_prototype,
        development_cost: formValues.estimatedDevelopmentCost,
        unit_cost: formValues.estimatedUnitCost,
        lpp_cost: formValues.llp,
        bulk_cost: formValues.bulk_cost,
        exchequer: formValues.exchequer,
        dual_technology : formValues.dual_technology,
        poev: formValues.poev,
        lpp_year: formValues.lpyear,
        indigenously_designed: formValues.indigenously_designed,
        capability_infrastructure: formValues.capability_infrastructure,
        ltpp: formValues.ltpp,
        technical_details: formValues.technologyInsertion,
        justification: formValues.justificationText,
        // export_potential: formValues.exportPotential,
        lead_development: formValues.lead_development,
        indigenise_equipment: formValues.indigenise_equipment,
        rfi_indigenous: formValues.rfi_indigenous,
        collaboration_envisaged: formValues.collaboration_envisaged,
        drdo_psu: formValues.drdo_psu,
        technical_specifications: formValues.technical_specifications,
        operational_requirement: formValues.operational_requirement,
        drawings_manuals: formValues.drawings_manuals,
        sample_indigenisation: formValues.sample_indigenisation,
        annual_Acquisition: formValues.annual_Acquisition,
        trials_environments: formValues.trials_environments,
        photograph_item: formValues.photograph_item,
        export_potential: formValues.export_potential,
        project_similar: formValues.project_similar,
        revenue_idex: formValues.revenue_idex,
        vinatge_oem: formValues.vinatge_oem,
        approval_apso: formValues.approval_apso,
        nodal_officer_details: formValues.nodalOfficerDetails,
        critical_technology: formValues.critical_technology,
        drdo_infrastructure: formValues.drdo_infrastructure,
        trial_infrastructure: formValues.trial_infrastructure,
      },
      route_conf: routePayload
    };


    // Create FormData similar to saveDraft
    const fd = new FormData();
    fd.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    const meta: any[] = [];
    (this.selectedDmsFiles || []).forEach((it: any, i: number) => {
      if (!it?.file) return;
      const name = it.name || `file_${i + 1}`;
      fd.append('files', it.file, name);
      meta.push({ id: it?.id, name, description: it.description || '', type_document: it.type || it.file?.type || '', date: it.date || '' });
    });
    fd.append('files_meta', new Blob([JSON.stringify(meta)], { type: 'application/json' }));

    const sub = this.apiService.postAPI('/make1/initiated/proposal/', fd).subscribe((res: any) => {
      // Handle different response structures
      this.selectedProposal = res?.proposal || res?.data || res;

      // Ensure we have the proposal ID - check multiple possible locations
      if (!this.selectedProposal?.id) {
        if (res?.proposal_id) {
          this.selectedProposal = { ...this.selectedProposal, id: res.proposal_id };
        } else if (res?.proposal?.id) {
          this.selectedProposal = { ...this.selectedProposal, id: res.proposal.id };
        } else if (res?.id) {
          this.selectedProposal = { ...this.selectedProposal, id: res.id };
        }
      }

      // Validate that we have a proposal ID before proceeding
      if (!this.selectedProposal?.id) {
        console.error('Proposal ID not found in response:', res);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Proposal created but ID not found in response. Please refresh and try again.'
        });
        return;
      }

      this.messageService.add({
        severity: 'success', summary: 'Success', detail: res.message || 'Proposal Created and Shared Successfully',
      });
      this.proposalForm.reset();
      this.proposalForm.patchValue({
        scheme: parseInt(this.currentSchemeId || this.currentsubSchemeId)
      });
      this.displayDialogN = false;

      // Reset sharing form
      this.resetSharingForm();
      this.selectedDmsFiles = [];
      this.getProposal();
      this.getStages(this.proposalForm.get('scheme')?.value, 'pass');
      this.onSchemeStatusTabChange(this.schemeStatusTabs[1]);
    }, (error) => {
      this.messageService.add({
        severity: 'error', summary: 'Error', detail: 'Failed to create and share proposal'
      });
    });

    this.subscriptions.add(sub);
  }

  // Add this method to reset sharing form
  resetSharingForm() {
    this.shareType = null;
    this.permissionType = null;
    this.selectedUser = null;
    this.selectedUsers = [];
    this.selectedUnit = null;
    this.selectedUnits = [];
    this.internalComment = '';
    this.externalComment = '';
  }

  // Add validation method
  isFormValid(): boolean {
    if (!this.shareType || !this.permissionType) return false;

    if (this.shareType === 'internal') {
      if (this.permissionType === 'edit') {
        return !!this.selectedUser;
      } else {
        return this.selectedUsers && this.selectedUsers.length > 0;
      }
    } else {
      if (this.permissionType === 'edit') {
        return !!this.selectedUnit;
      } else {
        return this.selectedUnits && this.selectedUnits.length > 0;
      }
    }
  }

  // Document upload handler
  onDocumentUpload(data: any) {
    this.selectedDmsFiles.push(data);
  }
}


export interface Proposal {
  [x: string]: any;
  id: number;
  isInitiator: boolean;
  isRecommender: boolean;
  isApprover: boolean;
  proposal_name: string;
  code: string;
  status: number;
  organisation: string;
  category: string;
  releaseDate: string | null;
  coordinated_agency: string;
  technology_domain: string;
  title: string;
  nodal_officer: string;
  problem_statement: string;
  challenge_brief: string;
  prototype_development: string;
  requirement: string;
  functional_advantages: string;
  domestic: string;
  substitution: string;
  preliminary_scope: string;
  competitive_solution: string;
  potential_market: string;
  risk_assessment: string;
  mpo_qty: string;
  ip_value: string | null;
  pds: string | null;
  pru: string | null;
  priority: string | null;
  proposalStep: number;
  created_on: string;
  modifiedOn: string;
  createdBy: number;
  modifiedBy: number;
  approved_by: number | null;
  selected?: any;
  release_date?: string;
  proposal_step?: any;
  next_proposal_step_id?: any;
  valuation?: string;
  launchStatus?: string;
  challenge_status?: string;
  ip_status?: string;
  current_proposal_step?: number;
}